import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import "./confirmAddClassModal.scss"

export default class ConfirmAddClassModal extends Component {

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
  };

  handleCancel (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
    const { onCancel } = this.props;
    onCancel();
  }

  handleConfirm (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
    const { onConfirm } = this.props;
    onConfirm();
  }

  onHide() {
    // Do nothing
  }

  render () {
    const { showModal } = this.props;

    return (
      <Modal show={showModal} onHide={::this.onHide} className="confirm-add-class">
        <Modal.Header>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <h4>
            It looks like you've already added your class for this program.<br/>
            Are you doing the program with multiple classes during this school year?
          </h4>

          <button
            className="btn btn-primary"
            onClick={::this.handleCancel}>
            No, I don't need to add an extra class
          </button>

          <button
              className="btn btn-default"
              onClick={::this.handleConfirm}>
            Yes, I want to add an extra class
          </button>

        </Modal.Body>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/dashboard/confirmAddClassModal.jsx